import React from 'react';
import { Form } from 'semantic-ui-react';

export enum MetricType {
  NPS = 1,
  CSAT = 2,
  CUSTOM_KPI = 3,
  GENERIC = 4,
  PILLAR = 5,
  OUTCOME = 6,
}

export const isPillarType = (metricType: number): boolean =>
  metricType === MetricType.PILLAR;

export const isOutcomeType = (metricType: number): boolean =>
  metricType === MetricType.OUTCOME;

export const METRIC_TYPE_OPTIONS = [
  { key: MetricType.NPS, text: 'Net Promoter Score (NPS)', value: MetricType.NPS },
  { key: MetricType.CSAT, text: 'Customer Satisfaction (CSAT)', value: MetricType.CSAT },
  { key: MetricType.CUSTOM_KPI, text: 'Custom KPI', value: MetricType.CUSTOM_KPI },
  { key: MetricType.GENERIC, text: 'Generic Metric', value: MetricType.GENERIC },
  { key: MetricType.PILLAR, text: 'Pillar', value: MetricType.PILLAR },
  { key: MetricType.OUTCOME, text: 'Outcome', value: MetricType.OUTCOME },
];

interface MetricTypeSelectorProps {
  value: number;
  onChange: (value: number) => void;
  error?: boolean;
  disabled?: boolean;
}

export const MetricTypeSelector: React.FC<MetricTypeSelectorProps> = ({
  value,
  onChange,
  error = false,
  disabled = false,
}) => (
  <Form.Select
    options={METRIC_TYPE_OPTIONS}
    value={value}
    onChange={(e, { value }) => onChange(value as number)}
    error={error}
    disabled={disabled}
    fluid
  />
);

export const getMetricTypeDisplay = (type: number, metricLabel?: string): string => {
  const option = METRIC_TYPE_OPTIONS.find(opt => opt.value === type);
  return option?.text || 'Unknown';
};

export const validateMetricValue = (type: number, value: number): string | null => {
  if (type === MetricType.NPS) {
    if (value < -100 || value > 100) {
      return 'NPS scores must be between -100 and 100';
    }
  } else if (type === MetricType.CSAT) {
    if (value < 0) {
      return 'CSAT scores cannot be negative';
    }
  }
  return null;
};

